import type React from "react";
import {memo, useMemo} from "react";

import SelectGeneric from "../SelectGeneric";

type SelectReservationLengthOption = {
    value: number;
    label: string;
};

function generateOptions() {
    const options: SelectReservationLengthOption[] = [];
    for (let i = -60; i <= 60; i += 1) {
        if (i === 1) {
            options.push({
                value: i,
                label: "Any Length"
            });
        } else if (i === -1) {
            options.push({
                value: i,
                label: "1 Night"
            });
        } else if (i !== 0) {
            let suffix = "More";
            if (i < 0) {
                suffix = "Less";
            }
            options.push({
                value: i,
                label: `${Math.abs(i)} Nights or ${suffix}`
            });
        }
    }
    return options;
}

type Props = {
    value?: number;
    isDisabled?: boolean;
    onChange: (value: number) => void;
};

const SelectReservationLength: React.FC<Props> = ({value = 1, onChange, isDisabled}) => {
    const options = useMemo(() => generateOptions(), []);

    return (
        <SelectGeneric
            isClearable={false}
            isDisabled={isDisabled}
            options={options}
            placeholder="Reservation Length..."
            testID="select-reservation-length"
            value={value}
            onChange={onChange}
        />
    );
};

export default memo(SelectReservationLength);
